import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing }) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    height: spacing(75),
    width: '100%',
    paddingLeft: spacing(71),
    borderBottom: `1px solid ${Theme.Colors.Grayscale.Twelve}`,
  },
  headerButtons: {
    display: 'flex',
    gap: '8px',
  },
  label: {
    marginBottom: spacing(4),
  },

  container: {
    display: 'grid',
    gap: spacing(24),
    padding: spacing(48),
    marginTop: spacing(24),
    gridRowGap: spacing(32),
    gridTemplateAreas: `"name slug ." "description description description " "initialPrompt initialPrompt initialPrompt" "tokenApi tokenApi tokenApi" "temperature maxTokens frequencyPenalty" "presencePenalty service model" "reasoningEffort . ." "isActive . ."`,
    gridTemplateColumns: '1fr 1fr 1fr',
  },

  button: {
    width: spacing(154),
    height: spacing(40),
    fontWeight: 'normal',
    fontSize: spacing(15),
    whiteSpace: 'nowrap',
  },
  name: {
    gridArea: 'name',
  },
  slug: {
    gridArea: 'slug',
  },
  description: {
    gridArea: 'description',
  },
  initialPrompt: {
    gridArea: 'initialPrompt',
  },
  tokenApi: {
    gridArea: 'tokenApi',
  },
  temperature: {
    gridArea: 'temperature',
  },
  maxTokens: {
    gridArea: 'maxTokens',
  },
  frequencyPenalty: {
    gridArea: 'frequencyPenalty',
  },
  presencePenalty: {
    gridArea: 'presencePenalty',
  },
  service: {
    gridArea: 'service',
  },
  model: {
    gridArea: 'model',
  },
  reasoningEffort: {
    gridArea: 'reasoningEffort',
  },
  isActive: {
    gridArea: 'isActive',
  },
}))
